import React from 'react';
import { useDispatch } from 'react-redux';

import SightingList from '../Lists/SightingList';

import { hideModal } from '../../actions/modal/modal';

const VerifySightings = () => {

  const dispatch = useDispatch();
  
  return (
    <>
      <span className="modal__close" onClick={ () => dispatch(hideModal()) }>&times;</span>

      <h3 className="modal__header">Manage Sightings</h3>

      <SightingList />
    </>
  );

}

export default VerifySightings;